import * as React from 'react';

import { Layout } from './Layout';
import { IProgressBarProps } from './types/public';
import { useFillWidth } from './utils/useFillWidth';

export const ProgressBar: React.FC<React.PropsWithChildren<IProgressBarProps>> = props => {
  const fillWidth = useFillWidth(props);

  return <Layout fillWidth={fillWidth} />;
};
